import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-save-deployment-settings",
  templateUrl: "./save-deployment-settings.component.html",
  styleUrls: ["./save-deployment-settings.component.scss"],
})
export class SaveDeploymentSettingsComponent implements OnInit {
  title: string = this.data.title;
  message: string = this.data.message;
  warningDialog: boolean = false;
  warningDialogContent: { originalAuthType: string; newAuthType: string };
  constructor(
    public dialog: MatDialogRef<SaveDeploymentSettingsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      warningDialog?: boolean;
      warningDialogContent?: { originalAuthType: string; newAuthType: string };
    }
  ) {}
  ngOnInit() {
    this.warningDialog = this.data.warningDialog || false;
    this.warningDialogContent = this.data.warningDialogContent || {
      originalAuthType: "",
      newAuthType: "",
    };
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(true);
  }
}
